module.exports = __webpack_public_path__ + "img/home-page4.d6d709e8.png";